import {
  JustShippedCardSchema
} from "./chunk-MPMCOLMP.mjs";
import {
  AnnouncementBannerSchema
} from "./chunk-BLNEU3OV.mjs";

// src/flags/flags.ts
import { z } from "zod";
var Flag = /* @__PURE__ */ ((Flag2) => {
  Flag2["ProductTimeseriesCharts"] = "product_timeseries_charts";
  Flag2["OrbUsageCharts"] = "orb_usage_charts";
  Flag2["RevampedSpendLimits"] = "revamped_spend_limits";
  Flag2["GrandfatheredBillingBanner"] = "grandfathered_billing_banner";
  Flag2["NewBillingEmails"] = "new_billing_emails";
  Flag2["DisablePlanChange"] = "disable_plan_change";
  Flag2["WebhookCreationTemplate"] = "webhook_creation_template";
  Flag2["AnnouncementBanner"] = "announcement_banner";
  Flag2["FeaturedChains"] = "featured_chains";
  Flag2["JustShippedCards"] = "just_shipped_cards";
  Flag2["OutageBanner"] = "outage_banner";
  Flag2["ScheduleCallPopover"] = "schedule_call_popover";
  Flag2["WalletServices"] = "wallet_services";
  Flag2["GlobalBanner"] = "global_banner";
  return Flag2;
})(Flag || {});
var FlagEnum = z.nativeEnum(Flag);
var UnvalidatedNetworkIdsSchema = z.object({
  networkIds: z.array(z.string())
});
var FLAG_SCHEMA_MAP = {
  // Feature gates
  ["product_timeseries_charts" /* ProductTimeseriesCharts */]: z.boolean(),
  ["orb_usage_charts" /* OrbUsageCharts */]: z.boolean(),
  ["revamped_spend_limits" /* RevampedSpendLimits */]: z.boolean(),
  ["grandfathered_billing_banner" /* GrandfatheredBillingBanner */]: z.boolean(),
  ["new_billing_emails" /* NewBillingEmails */]: z.boolean(),
  ["disable_plan_change" /* DisablePlanChange */]: z.boolean(),
  // Experiments
  ["webhook_creation_template" /* WebhookCreationTemplate */]: z.object({ is_test: z.boolean() }),
  // Dynamic configs
  ["featured_chains" /* FeaturedChains */]: z.object({
    featuredChainIds: z.array(z.string()),
    popularChainIds: z.array(z.string())
  }),
  ["just_shipped_cards" /* JustShippedCards */]: z.object({
    cards: z.array(JustShippedCardSchema)
  }),
  ["announcement_banner" /* AnnouncementBanner */]: z.object({
    banners: z.array(AnnouncementBannerSchema)
  }),
  ["outage_banner" /* OutageBanner */]: z.object({
    enabled: z.boolean(),
    message: z.string()
  }),
  ["schedule_call_popover" /* ScheduleCallPopover */]: z.object({
    ctaText: z.string(),
    ctaUrl: z.string().url(),
    // URLs are already being validated by the Statsig dynamic config
    description: z.string(),
    openPopoverText: z.string(),
    enabled: z.boolean()
  }),
  ["wallet_services" /* WalletServices */]: z.object({
    gasManager: UnvalidatedNetworkIdsSchema
  }),
  ["global_banner" /* GlobalBanner */]: z.object({
    contentMd: z.string(),
    variant: z.enum(["info", "warning", "error"])
  })
};
var flagSchemaMap = z.object(FLAG_SCHEMA_MAP);
var FLAG_DEFAULTS = {
  ["product_timeseries_charts" /* ProductTimeseriesCharts */]: false,
  ["orb_usage_charts" /* OrbUsageCharts */]: false,
  ["revamped_spend_limits" /* RevampedSpendLimits */]: false,
  ["grandfathered_billing_banner" /* GrandfatheredBillingBanner */]: false,
  ["new_billing_emails" /* NewBillingEmails */]: false,
  ["disable_plan_change" /* DisablePlanChange */]: false,
  // Experiments
  ["webhook_creation_template" /* WebhookCreationTemplate */]: { is_test: false },
  // Dynamic configs
  ["announcement_banner" /* AnnouncementBanner */]: { banners: [] },
  ["featured_chains" /* FeaturedChains */]: { featuredChainIds: [], popularChainIds: [] },
  ["just_shipped_cards" /* JustShippedCards */]: { cards: [] },
  ["outage_banner" /* OutageBanner */]: { enabled: false, message: "" },
  ["schedule_call_popover" /* ScheduleCallPopover */]: {
    ctaText: "",
    ctaUrl: "",
    description: "",
    openPopoverText: "",
    enabled: false
  },
  ["wallet_services" /* WalletServices */]: {
    gasManager: { networkIds: [] }
  },
  ["global_banner" /* GlobalBanner */]: { contentMd: "", variant: "info" }
};

export {
  Flag,
  FlagEnum,
  FLAG_SCHEMA_MAP,
  flagSchemaMap,
  FLAG_DEFAULTS
};
//# sourceMappingURL=chunk-3TUMQD7H.mjs.map